// extracted by mini-css-extract-plugin
module.exports = {"row-divider":"RecurringDepositConfirmation_row-divider_3Qjw4"};